export const TEMPLATE_LINT_DISABLE = /^{{!\s*template-lint-disable(?<lintRules>.*)}}\n/;
export const ESLINT_DISABLE = /^\/\*\s*eslint-disable(?<lintRules>.*)\*\/\n/;
